<template>
  <div :style="containerStyle">
    <div :style="innerContainerStyle">
      <HeaderLargeLight>
        Language & Region
      </HeaderLargeLight>
      <CardSecondary :style="cardStyle">
        <SelectPrimary v-if="languageOptionIndex !== null"
                       :initSelectedOptionIndex="languageOptionIndex"
                       :options="languageList"
                       @select="selectLanguage">
          <template v-slot:label>
            Language
          </template>
          <template v-slot:select>
            {{ languageList.length > 0 ? languageList[languageOptionIndex].label : '' }}
          </template>
        </SelectPrimary>
        <SelectPrimary v-if="timezoneOptionIndex !== null"
                       :initSelectedOptionIndex="timezoneOptionIndex"
                       :options="timezoneList"
                       :style="selectStyle"
                       @select="selectTimezone">
          <template v-slot:label>
            Timezone
          </template>
          <template v-slot:select>
            <template v-if="timezoneList.length > 0">
              {{ timezoneList[timezoneOptionIndex].label}}
            </template>
          </template>
        </SelectPrimary>
        <div :style="buttonsContainerStyle">
          <ButtonPrimary :style="buttonStyle" @click="update">
            Update
          </ButtonPrimary>
        </div>
      </CardSecondary>
    </div>
  </div>
</template>

<script>
  import ApiCurrentUser from '@js/api/current-user'
  import ButtonPrimary from '@modules/button/button-primary'
  import CardSecondary from '@modules/card/card-secondary'
  import HeaderLargeLight from '@modules/text/header-large-light'
  import SelectPrimary from '@modules/select/select-primary'
  import { Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UserLocaleView',
    components: {
      ButtonPrimary,
      CardSecondary,
      HeaderLargeLight,
      SelectPrimary,
    },
    data: function () {
      return {
        buttonsContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: Layout.space.xl,
        },
        buttonStyle: {
          display: 'block',
          marginLeft: Layout.space.md,
          minWidth: '82px',
        },
        cardStyle: {
          marginTop: Layout.space.lg,
          padding: Layout.space.lg,
        },
        containerStyle: {
          height: '400px',
        },
        innerContainerStyle: {
          maxWidth: '608px',
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          padding: `0 ${Layout.space.lg}`,
          width: '100%',
        },
        languageList: [],
        languageOptionIndex: null,
        selectStyle: {
          marginTop: Layout.space.lg,
        },
        timezoneList: [],
        timezoneOptionIndex: null,
      };
    },
    created: function () {
      this.languageList = this.languageCodes.map(
        elem => { return { ...elem, label: elem.displayName }; });
      this.timezoneList = this.timezoneCodes.map(
        elem => {
          const utc = ` (UTC${elem.utcOffset}, UTC DST${elem.utcDstOffset})`;
          return { ...elem, label: `${elem.name}${utc}` }; });
      this.languageOptionIndex = this.getIndexByLanguageCode(
        this.user.languageCode);
      this.timezoneOptionIndex = this.getIndexByTimezoneCode(
        this.user.timezoneCode);
    },
    computed: {
      ...mapGetters(
        'serviceParams', [
          'getIndexByLanguageCode', 'getLanguageCodeByIndex',
          'getIndexByTimezoneCode', 'getTimezoneCodeByIndex',]),
      ...mapState({
        languageCodes: state => state.serviceParams.languageCodes,
        timezoneCodes: state => state.serviceParams.timezoneCodes,
        user: state => state.user,
      }),
    },
    methods: {
      update: async function () {
        try {
          const payload = await {
            languageCode: this.languageList[this.languageOptionIndex].code,
            timezoneCode: this.timezoneList[this.timezoneOptionIndex].name,
          };
          const api = await new ApiCurrentUser();
          const res = await api.put(payload);
          //await this.$store.dispatch('user/updateUser', payload);
          await this.$store.commit('notification/setMessage', 'Updated');
        } catch (error) {
          console.error(error);
        }
      },
      selectLanguage: function (index) {
        this.languageOptionIndex = index;
      },
      selectTimezone: function (index) {
        this.timezoneOptionIndex = index;
      },
    },
  };
</script>
